import { Table } from 'react-bootstrap';
import styled from 'styled-components';
import { useDenominaciones } from '../../../../../appStore/denominaciones';
import { ROLES } from '../../../../../const';
import { useConcurso } from '../../../../../providers/ConcursoProvider';
import { useCheckRoles } from '../../../../hooks';
import { PuestoRowPublico } from './PuestoRowPublico';

const Scrollable = styled.div`
  overflow: auto;
  max-height: 500px;
`;

export const MainTablePublica = () => {
  const { dataPublico } = useDenominaciones();
  const isUser = useCheckRoles([ROLES.USER]);
  const { etapaLlamadoConcurso } = useConcurso();

  return (
    <>
      <Scrollable>
        <Table bordered hover size="sm">
          <thead>
            <tr>
              {isUser && etapaLlamadoConcurso.idEtapaLlamadoConcurso === 9 && (
                <th className="text-center align-middle">Inscribirme</th>
              )}
              <th className="text-center align-middle">Ubicación Estructural - Dependencia</th>
              <th className="text-center align-middle">Denominación del Puesto</th>
              <th className="text-center align-middle">Nivel</th>
              <th className="text-center align-middle">Agrupamiento</th>
              <th className="text-center align-middle">Reserva Ley N° 22.431</th>
              <th className="text-center align-middle">Capac. Terc.</th>
              <th className="text-center align-middle">Func. Especif.</th>
              <th className="text-center align-middle">Cantidad</th>
              <th className="text-center align-middle">Acciones</th>
              <th className="text-center align-middle">Ver bases</th>
            </tr>
          </thead>

          <tbody>
            {dataPublico?.map((puesto, i) => {
              return <PuestoRowPublico key={`${puesto.idPuesto}`} {...puesto} />;
            })}
          </tbody>
        </Table>
      </Scrollable>
    </>
  );
};
